import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import './resetsenha.css';

import firebase from '../Config/firebase';
import {getAuth, sendPasswordResetEmail} from 'firebase/auth';

function ResetSenha(){
    const [email,setEmail] = useState('');
    const [mensagem,setMensagem] = useState('');
    const auth = getAuth();

    function recuperarSenha(){
        sendPasswordResetEmail(auth,email)
          .then(resultado => {
          setMensagem('');
          setMensagem('Email enviado com sucesso');
        })
        .catch(erro => {
          setMensagem('Erro ao enviar o email' + erro.message);
        })
      }

    return <div className="tstcor1">
       <div className="mm2">
        <form>
            <img className="tstimg" src="/images/logo8.png" alt="" />
            <h1 className="testeh3">Informe seu e_mail, em seguida abra a mensagem que recebeu para recuperar a senha</h1>
            <div className="form-floating">
            <input onChange={(e) => setEmail(e.target.value)} type="email" className="form-control  inptlg" id="floatingInput" placeholder="E-mail" />
            <label className="flt1" htmlFor="floatingInput">E-mail</label>
            </div>

            <button onClick={recuperarSenha} className="btn btn-primary py-2 butace" type="button">Enviar</button>

            {mensagem.length>0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}

            <div className="mt-4">
                <Link to="/app" className="mx-3 lnk4">Já tenho uma conta</Link> 
            </div>
            <p className="mt-3 mb-3 text-white-50 tstcopy">&copy; Desenvolvido por Fernando Barros</p>
       </form>
      </div>
        </div>;
  }

  export default ResetSenha;